import { useCallback, useState } from "react";
import { IEirSalesPrequal } from "@modules/eirSalesFacade/interfaces/models/IEirSalesPrequal";
import { useDeviceType } from "@hooks/useDeviceType";
import { useOfferAddons } from "@modules/eirSalesFacade/swr/offerAddons";

interface IParams {
    hasBroadbandOfferInCart?: boolean;
    handleDeleteBroadbandOffer(): void;
    cartOfferId?: number;
}

export const useHomeBroadbandSidePanel = (props: IParams) => {
    const { hasBroadbandOfferInCart, handleDeleteBroadbandOffer, cartOfferId } = props;
    const [prequal, setPrequal] = useState<IEirSalesPrequal>();
    const { isMobile } = useDeviceType();

    const { data: offerAddonList } = useOfferAddons(cartOfferId);

    const resetPrequal = useCallback(() => setPrequal(undefined), []);

    const handleChangeAddress = useCallback(() => {
        if (hasBroadbandOfferInCart) {
            handleDeleteBroadbandOffer();
        }

        resetPrequal();
    }, [handleDeleteBroadbandOffer, hasBroadbandOfferInCart, resetPrequal]);

    return {
        prequal,
        setPrequal,
        resetPrequal,
        handleChangeAddress,
        isMobile,
        offerAddonList,
    };
};
